module.exports = __webpack_public_path__ + "img/Star.6c6f3726.svg";